import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["videoWrapper", "video"]

  connect() {
    document.addEventListener("keydown", this.hideHandler.bind(this))
  }

  disconnect() {
    document.removeEventListener("keydown", this.hideHandler.bind(this))
  }

  hideHandler(event) {
    if (event.keyCode == 27) {
      this.hide(event)
    }
  }

  show(event) {
    event.preventDefault()
    this.videoWrapperTarget.classList.add("show")
    try {
      this.videoTarget.play()
    } catch (e) {
      console.log("Error", e)
    }
  }

  hide(event) {
    event.preventDefault()
    this.videoWrapperTarget.classList.remove("show")
    this.videoTarget.pause()
  }
}
